<div
    class="opf-page dss-mt-md-3 dss-mt-sm-2"
    [ngClass]="{
        'opf-page--is-loading': pageService.isPageLoading,
        'opf-page-centered': mode === 'centered'
    }"
>
    <div class="row">
        <div
            class="col-xs-12 offset-xs-0 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2"
        >
            <div class="row opf-page__header">
                <div class="col-md-12 p-md-0">
                    <span
                        class="dss-icon__extra-large dss-icon-{{
                            icon
                        }} opf-page-__border__icon"
                        [ngClass]="{
                            'opf-page__header__icon--hidden':
                                mode !== 'centered'
                        }"
                    ></span>
                    <h2
                        dssTypography
                        type="h2"
                        class="opf-page__header__title"
                        [innerHtml]="title"
                    ></h2>
                    <h3
                        dssTypography
                        type="h3"
                        class="opf-page__header__subtitle"
                        [innerHtml]="subtitle"
                    ></h3>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-content select="[fullSizeContent]"></ng-content>

<div
    class="opf-page"
    [ngClass]="{
        'opf-page--is-loading': pageService.isPageLoading,
        'opf-page-centered': mode === 'centered'
    }"
>
    <div class="row">
        <div
            class="col-xs-12 offset-xs-0 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2"
        >
            <div class="row">
                <div class="col-md-12 opf-page__body pl-md-0">
                    <div class="row">
                        <div class="col-md-12">
                            <ng-content></ng-content>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div
                    class="col-md-12 opf-page__footer"
                    [ngClass]="{
                        'opf-page__footer--no-border':
                            !primaryAction?.text || !secondaryAction?.text
                    }"
                >
                    <mob-button
                        *ngIf="primaryAction?.text"
                        [type]="'primary'"
                        (actionClick)="onActionClick($event)"
                        [text]="primaryAction?.text"
                        [eventLabel]="primaryAction?.eventLabel"
                        [action]="primaryAction?.actionName"
                        [disabled]="!primaryActionEnabled"
                        elementId="pagePrimaryButton"
                    >
                    </mob-button>
                    <mob-button
                        *ngIf="secondaryAction?.text"
                        [type]="'secondary'"
                        (actionClick)="onActionClick($event)"
                        [text]="secondaryAction?.text"
                        [eventLabel]="secondaryAction?.eventLabel"
                        [action]="secondaryAction?.actionName"
                        [disabled]="!secondaryActionEnabled"
                        elementId="pageSecondaryButton"
                    >
                    </mob-button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ERROR DIALOG -->
<dss-dialog [open]="openErrorDialog" class="dss-dialog-error">
    <dss-dialog-header>
        <div>{{ error?.title }}</div>
    </dss-dialog-header>
    <dss-dialog-body>
        <p [innerHtml]="error?.description"></p>
    </dss-dialog-body>
    <dss-dialog-footer>
        <button dssOutlineButton (click)="goToAction(error)">
            {{ error?.firstAction.title }}
        </button>
    </dss-dialog-footer>
</dss-dialog>

